/* eslint-disable max-len */
import React from "react";

interface SVGRProps {
    title?: string;
    titleId?: string;
}

function CloseIcon({ title, titleId, ...props }: React.SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg {...props} viewBox="0 0 18 19" aria-hidden="true" height="1em" width="1em">
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M.818 1.258l16.417 16.418m-.053-16.418L.765 17.676"
                fill="none"
                fillRule="evenodd"
                stroke="#333"
                strokeWidth="1.35"
            />
        </svg>
    );
}

export default CloseIcon;
